const MSH_HAS_TANGENTS = 1 << 0;
const MSH_HAS_SKELETON = 1 << 1;
const MSH_HAS_SKELETON_8 = 1 << 2;
const MSH_HAS_MORPH_TARGETS = 1 << 3;
const MSH_HAS_THIN_INSTANCES = 1 << 4;
const MSH_HAS_INSTANCE_COLOR = 1 << 5;
const MSH_HAS_VERTEX_COLOR = 1 << 6;
const MSH_HAS_UV2 = 1 << 7;
const MSH_RECEIVE_SHADOWS = 1 << 8;
const MSH_VAT = 1 << 9;
const MSH_FLAT_NORMAL = 1 << 10;
let _meshFeatureExtra = null;
function _installMeshFeatureExtra(encode) {
  _meshFeatureExtra = encode;
}
function _computeMeshFeatures(mesh, receiveShadows = false) {
  const gpu = mesh._gpu;
  let features = 0;
  if (gpu.tangentBuffer) {
    features |= MSH_HAS_TANGENTS;
  }
  if (mesh.vat) {
    features |= MSH_VAT;
    if (mesh.vat.joints1Buffer) {
      features |= MSH_HAS_SKELETON_8;
    }
  } else if (mesh.skeleton) {
    features |= MSH_HAS_SKELETON;
    if (mesh.skeleton.joints1Buffer) {
      features |= MSH_HAS_SKELETON_8;
    }
  }
  if (mesh.morphTargets) {
    features |= MSH_HAS_MORPH_TARGETS;
  }
  if (mesh.thinInstances) {
    features |= MSH_HAS_THIN_INSTANCES;
    if (mesh.thinInstances.colors) {
      features |= MSH_HAS_INSTANCE_COLOR;
    }
  }
  if (gpu.colorBuffer) {
    features |= MSH_HAS_VERTEX_COLOR;
  }
  if (gpu.uv2Buffer) {
    features |= MSH_HAS_UV2;
  }
  if (mesh._flatNormal) {
    features |= MSH_FLAT_NORMAL;
  }
  if (receiveShadows) {
    features |= MSH_RECEIVE_SHADOWS;
  }
  if (_meshFeatureExtra) {
    features |= _meshFeatureExtra(mesh);
  }
  return features;
}

export { MSH_FLAT_NORMAL, MSH_HAS_INSTANCE_COLOR, MSH_HAS_MORPH_TARGETS, MSH_HAS_SKELETON, MSH_HAS_SKELETON_8, MSH_HAS_TANGENTS, MSH_HAS_THIN_INSTANCES, MSH_HAS_UV2, MSH_HAS_VERTEX_COLOR, MSH_RECEIVE_SHADOWS, MSH_VAT, _computeMeshFeatures, _installMeshFeatureExtra };
//# sourceMappingURL=mesh-features.js.map
